export default "__VITE_ASSET__BhX7WjgJ__"